import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ArticleStockInfoList, StockInfoDetails, StockLookup } from '../../model';
import { Occ } from '../../occ';
import { ConverterService } from '../../util';
import { STOCK_INFO_DETAIL_NORMALIZER, STOCK_INFO_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class StockInfoConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  getStockInfo(input: Array<StockLookup>): Observable<ArticleStockInfoList> {
    const userId = input[0]?.userId;
    const payload = input.map((sl) => {
      return { articleNumber: sl.articleNumber, quantity: sl.quantity, unit: sl.unit };
    });
    const url = this.occEndpointsService.buildUrl('stockInfos', { urlParams: { userId } });
    return this.httpClient
      .post<Occ.ArticleStockInfoList>(url, { priceRequests: payload })
      .pipe(this.converterService.pipeable(STOCK_INFO_NORMALIZER));
  }

  getStockInfoDetails(input: StockLookup): Observable<StockInfoDetails> {
    const url = this.occEndpointsService.buildUrl('stockInfo', {
      urlParams: {
        userId: input.userId,
        articleNumber: input.articleNumber,
      },
      queryParams: {
        quantity: input.quantity,
      },
    });
    return this.httpClient.get(url).pipe(this.converterService.pipeable(STOCK_INFO_DETAIL_NORMALIZER));
  }
}
